import {
  FormControl,
  FormLabel,
  Input,
  Flex,
  Button,
  useBoolean,
  InputGroup,
  InputRightElement,
  FormErrorMessage,
} from "@chakra-ui/react";
import { checkEmail, checkUserName } from "lib/redux/auth/action";
import { type RootReducer } from "lib/redux/reducers";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { errorToast, successToast } from "utils/hooks";
import { postRequest, useMutationWrapper } from "services/apiHelper";
import { authRequest } from "services/request";
import { userKey } from "utils/constants";

const RegisterForm = () => {
  const VARIANT_COLOR = "#1F74Db";
  const history = useNavigate();

  const dispatch = useDispatch();
  const login = useSelector<RootReducer, any>((state) => state.auth.user);
  const validUserName = useSelector<RootReducer, any>((state) => state.auth.userName);
  const validEmail = useSelector<RootReducer, any>((state) => state.auth.email);
  useEffect(() => {
    if (login.success === true) {
      history("/dashboard");
    }
  }, [history, login]);

  const [formData, setformData] = useState({
    userName: "",
    verificationCode: "",
    email: "",
    password: "",
    password2: "",
  });
  const { userName, verificationCode, password, password2, email } = formData;

  const handleChange = (e: any) => {
    setuserNameError(false);

    setformData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const [show, setShow] = useBoolean();
  const [userNameError, setuserNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const onSuccessReg = (res) => {
    const token = res.data.token;

    localStorage.setItem(userKey, token);

    history("/dashboard");
  };

  const { mutate: sendToAPI } = useMutationWrapper(postRequest, onSuccessReg);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== password2) {
      errorToast("Passwords do not match");
      return;
    }

    try {
      sendToAPI({
        url: authRequest.REGISTER,
        data: {
          userName: userName.toLowerCase(),
          email: email.toLowerCase(),
          password,
          verificationCode,
        },
      });
    } catch (error) {}
  };

  const handleBlur = () => {
    if (userName) {
      if (userName.length > 2) {
        dispatch(checkUserName({ userName }));
      } else {
        errorToast("userName must be greater than 3 characters");
      }
    }
  };
  const onSuccess = ({ data }) => {
    successToast(data);
  };
  const onError = ({ data }) => {
    errorToast(data);
  };

  const { mutate, isLoading } = useMutationWrapper(postRequest, onSuccess, onError);

  const getCode = () => {
    mutate({
      url: authRequest.SEND_VERIFICATION_CODE,
      data: { email },
    });
  };

  const handleEmailBlur = () => {
    if (email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(String(email).toLowerCase())) {
        dispatch(checkEmail({ email }));
      } else {
        errorToast("Please input a valid email");
      }
    }
  };
  useEffect(() => {
    const { processing, processed, success } = validUserName;
    if (!processing && processed && success) {
      setuserNameError(false);
    } else if (!processing && processed && !success) {
      setuserNameError(true);
    }
    // eslint-disable-next-line
  }, [validUserName]);
  useEffect(() => {
    const { processing, processed, success } = validEmail;
    if (!processing && processed && success) {
      setEmailError(false);
    } else if (!processing && processed && !success) {
      setEmailError(true);
    }
    // eslint-disable-next-line
  }, [validEmail]);

  return (
    <form onSubmit={handleSubmit}>
      <FormControl isRequired isInvalid={emailError}>
        <FormLabel mb={1}>Email address</FormLabel>
        <Flex alignItems="center">
          <Input
            type="email"
            placeholder="Enter your email address"
            name="email"
            value={email}
            onChange={handleChange}
            onBlur={handleEmailBlur}
          />
          <Button
            variant="secondary"
            ml="4"
            fontSize="14px"
            onClick={getCode}
            disabled={email === "" || emailError}
            isLoading={isLoading}
          >
            Get Code
          </Button>
        </Flex>
        <FormErrorMessage>{`This email ${email} is not avaliable`}</FormErrorMessage>
      </FormControl>

      <FormControl isRequired mt={4}>
        <FormLabel mb={1}>Verification Code</FormLabel>
        <Input
          type="text"
          placeholder="Enter code sent to email address"
          name="verificationCode"
          value={verificationCode}
          onChange={handleChange}
        />
        <FormErrorMessage>{"Plesae check your email and input code"}</FormErrorMessage>
      </FormControl>

      <FormControl isRequired mt={4} isInvalid={userNameError}>
        <FormLabel mb={1}>Username</FormLabel>
        <Input
          type="text"
          autoComplete="userName"
          placeholder="Enter your username"
          name="userName"
          value={userName}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <FormErrorMessage>{`The Username ${userName} is not avaliable`}</FormErrorMessage>
      </FormControl>
      <FormControl isRequired mt={4}>
        <FormLabel mb={1}>Password</FormLabel>
        <InputGroup size="md">
          <Input
            autoComplete="new-password"
            placeholder="Enter your password"
            name="password"
            value={password}
            onChange={handleChange}
            pr="4.5rem"
            type={show ? "text" : "password"}
          />
          <InputRightElement width="4.5rem">
            <Button
              h="1.75rem"
              size="sm"
              variant="secondaryOutline"
              onClick={() => {
                setShow.toggle();
              }}
            >
              {show ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
      </FormControl>
      <FormControl isRequired mt={4}>
        <FormLabel mb={1}>Confirm Password</FormLabel>
        <InputGroup size="md">
          <Input
            autoComplete="new-password"
            name="password2"
            value={password2}
            onChange={handleChange}
            placeholder="Re-enter your password"
            pr="4.5rem"
            type={show ? "text" : "password"}
          />
          <InputRightElement width="4.5rem">
            <Button
              h="1.75rem"
              size="sm"
              variant="secondaryOutline"
              onClick={() => {
                setShow.toggle();
              }}
            >
              {show ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
      </FormControl>

      <Flex justifyContent="space-between" mt={4}>
        <Button type="submit" mt={4} ml="4" fontSize="14px">
          Create Account
        </Button>

        <Button
          mt={4}
          onClick={() => {
            history("/user/login");
          }}
          variant="none"
          color={VARIANT_COLOR}
          fontSize="14px"
        >
          Log in
        </Button>
      </Flex>
    </form>
  );
};
export default RegisterForm;
